// Constants for data attributes and selectors
const DATA_ATTRIBUTES = {
  COLLECTION_HANDLE: 'data-collection-handle',
  FILTER_LABEL: 'data-filter-label',
  FILTER_KEY: 'data-filter-key',
  FILTER_VALUE: 'data-value',
  LANG_URL: 'data-lang-url',
};

const SELECTORS = {
  FILTERS_DIV: '.product-selector__filters',
  BUTTON: '.product-selector__button',
  SELECT: 'select',
  FACETS_CONTAINER: '.facets__container',
  FACET_DISCLOSURE: '.facets__disclosure',
  CHECKBOX: 'input[type="checkbox"]',
  FILTER_PARENT: '.product-selector__filter',
};

if (!customElements.get('product-selector')) {
  customElements.define(
    'product-selector',
    class ProductSelector extends HTMLElement {
      constructor() {
        super();
        this.initializeElements();
        this.initializeLanguagePrefix();

        if (this.collectionHandle) {
          this.fetchCollectionFilters();
        }

        this.addEventListeners();
      }

      initializeElements() {
        this.filtersDiv = this.querySelector(SELECTORS.FILTERS_DIV);
        this.button = this.querySelector(SELECTORS.BUTTON);
        this.selects = this.filtersDiv.querySelectorAll(SELECTORS.SELECT);
        this.collectionHandle = this.filtersDiv.getAttribute(DATA_ATTRIBUTES.COLLECTION_HANDLE);
      }

      initializeLanguagePrefix() {
        const langPrefix = this.getAttribute(DATA_ATTRIBUTES.LANG_URL) || '';
        this.langPrefix = langPrefix === '/' ? '' : langPrefix;
      }

      async fetchCollectionFilters() {
        try {
          const response = await fetch(`${this.langPrefix}/collections/${this.collectionHandle}`);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const facetsContainer = html.querySelector(SELECTORS.FACETS_CONTAINER);

          if (!facetsContainer) {
            console.warn('Facets container not found');
            return;
          }

          this.processSelects(facetsContainer);
        } catch (error) {
          console.error('Error fetching collection filters:', error);
        }
      }

      processSelects(facetsContainer) {
        Array.from(this.selects).forEach((select) => {
          const selectLabel = select.getAttribute(DATA_ATTRIBUTES.FILTER_LABEL);
          const facetItem = facetsContainer.querySelector(
            `${SELECTORS.FACET_DISCLOSURE}[data-facet-name="${selectLabel}"]`,
          );

          if (!facetItem) {
            this.hideFilterParent(select);
            return;
          }

          this.processFacetItem(select, facetItem);
        });
      }

      hideFilterParent(select) {
        const filterParent = select.closest(SELECTORS.FILTER_PARENT);
        if (filterParent) {
          filterParent.style.display = 'none';
        }
      }

      processFacetItem(select, facetItem) {
        const facetParamName = facetItem.getAttribute('data-facet-param-name');
        const selectLabel = select.getAttribute(DATA_ATTRIBUTES.FILTER_LABEL);

        if (!selectLabel || !facetParamName) {
          return;
        }

        select.setAttribute(DATA_ATTRIBUTES.FILTER_KEY, facetParamName);
        this.addOptionsFromCheckboxes(select, facetItem);
      }

      addOptionsFromCheckboxes(select, facetItem) {
        const checkboxes = facetItem.querySelectorAll(SELECTORS.CHECKBOX);

        checkboxes.forEach((checkbox) => {
          const option = document.createElement('option');
          option.value = checkbox.value;
          option.setAttribute(DATA_ATTRIBUTES.FILTER_VALUE, checkbox.value);
          option.textContent = checkbox.getAttribute('data-label');
          select.appendChild(option);
          const customSelect = select.closest('custom-select');
          if (customSelect) {
            customSelect.refresh();
          }
        });

        this.updateUrl();
      }

      updateUrl() {
        const urlParams = new URLSearchParams();
        this.addSelectedOptionsToParams(urlParams);

        const url = `${this.langPrefix}/collections/${this.collectionHandle}?${urlParams.toString()}`;
        this.updateButtonState(url);
      }

      addSelectedOptionsToParams(urlParams) {
        this.selects.forEach((select) => {
          const selectedOption = select.querySelector('option:not([disabled]):checked');
          if (!selectedOption) return;

          const filterKey = select.getAttribute(DATA_ATTRIBUTES.FILTER_KEY);
          const value = selectedOption.getAttribute(DATA_ATTRIBUTES.FILTER_VALUE) || selectedOption.value;
          urlParams.append(filterKey, value);
        });
      }

      updateButtonState(url) {
        this.button.setAttribute('href', url);
        this.button.removeAttribute('aria-disabled');
      }

      addEventListeners() {
        this.selects.forEach((select) => {
          select.addEventListener('change', () => {
            this.updateUrl();
          });
        });
      }
    },
  );
}
